'use strict';

var bind = require(129);

var $apply = require(64);
var $call = require(65);
var $reflectApply = require(67);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);
